<template>
  <div style="padding-bottom: 64px;">
    <!-- <van-nav-bar
      title="求职意向"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    >
    </van-nav-bar> -->
    <intention-common :isShow="false" @submit="submit">
      <template>
        <div class="fixed-bottom">
          <van-button
            v-if="id && total > 1"
            type="primary"
            class="btn-org-border"
            color="#FFF9F9"
            round
            @click="del(id)"
            >删 除</van-button
          >
          <van-button
            type="primary"
            class="btn-blue"
            color="linear-gradient(to right top, #2F72F6,#1C54CF)"
            round
            native-type="submit"
            >保 存</van-button
          >
        </div>
      </template>
    </intention-common>
  </div>
</template>

<script>
import IntentionCommon from '../components/IntentionCommon.vue';
export default {
  name: "intention",
  components: { IntentionCommon },
  data() {
    return {
      id: this.$route.query.id,
      total: this.$route.query.total,
    };
  },
  methods: {
    del(id) {
      this.module.api.intentionDelete({
        params: { id },
        success: res => {
          this.toast("删除成功");
          this.onClickLeft();
        }
      });
    },
    submit(val) {
      const { salaryExpect, workType } = val;
      const detail = Object.assign({}, val, {
        salaryExpect: this.module.salaryMap.get(salaryExpect),
        workType: this.module.workType.get(workType)
      });
      this.module.api.intentionSubmit({
        params: detail,
        success: res => {
          this.toast("保存成功");
          this.onClickLeft();
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  padding: 20px 16px;
}
.fixed-bottom {
  padding: 10px 16px 20px;
  button {
    flex: 2;
  }
  .btn-org-border {
    border: 1px solid #ff5945 !important;
    box-shadow: none;
    margin-right: 16px;
    flex: 1;
    color: #ff5945;
    .van-button__text {
      color: #ff5945;
    }
  }
}
</style>
